import { apiClient } from 'api/client/apiClient';
import { API_URLS } from '../consts';

export const fetchAvailableProviders = async () => {
  const result = await apiClient.get<string[]>(`${API_URLS.ProjectManagementSystem}/available-providers`);

  return result.data;
};
